export default {
  cloneFromType: {
    survey: 'Formulaire',
    template: 'Modèle',
  },
  createSurvey: 'Créer un formulaire',
  createTemplate: 'Créer un modèle',
  newSurvey: 'Nouveau formulaire',
  newSurveyFromScratch: 'Nouveau formulaire de zéro',
  newTemplate: 'Nouveau modèle',
  newTemplateFromScratch: 'Nouveau modèle de zéro',
  source: {
    label: 'Source',
    arena: 'Arena (.zip)',
    collect: 'Collect (.collect, .collect-backup, .collect-data)',
    odk: 'ODK (.xml)',
  },
  startImport: "Démarrer l'importation",
  survey: 'Formulaire',
  survey_other: 'Formulaires',
  template: 'Modèle',
  template_other: 'Modèles',
  error: 'Erreur lors de la création du nouveau formulaire',
  errorMaxSurveysCountExceeded: `Erreur lors de la création du formulaire ; vous avez atteint le nombre maximum de formulaires que vous pouvez créer ({{maxSurveysCount}}).`,
  options: {
    includeData: 'Inclure les données',
  },
}
